export default [
  {
    path: '/purchase/suppliers',
    name: 'purchase.suppliers',
    meta: {
      authRequired: true
    },
    component: () => import('@/router/views/purchase/suppliers/list/grid')
  }
]
